import { render, staticRenderFns } from "./ownerDetailRoomFee.vue?vue&type=template&id=78d3fc76"
import script from "./ownerDetailRoomFee.vue?vue&type=script&lang=js"
export * from "./ownerDetailRoomFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports